export enum InvoiceExtraType {
  ADDITIVE = 'ADDITIVE',
  SUBTRACTIVE = 'SUBTRACTIVE',
}

export const InvoiceExtraTypeMap: Record<InvoiceExtraType, string> = {
  [InvoiceExtraType.ADDITIVE]: 'Addition',
  [InvoiceExtraType.SUBTRACTIVE]: 'Subtraction',
};
